export default "__VITE_ASSET__ACFp9P2D__"